import * as React from "react";
import type { SVGProps } from "react";
const SvgSearch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M16.927 17.04 20.4 20.4m-9-13.2a3.6 3.6 0 0 1 3.6 3.6m4.28.64a7.84 7.84 0 1 1-15.68 0 7.84 7.84 0 0 1 15.68 0Z"
    />
  </svg>
);
export default SvgSearch02;
